import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import rootSaga from "./rootSaga";

// Reducers
import adminReducer from "./AdminList/adminSlice";
import sipplanReducer from "./SipPlan/SipPlanSlice";
import blocklistReducer from "./Blocklist/BlocklistSlice";
import jewellerReducer from "./JewellerList/JewellerSlice";
import counterReducer from "./slices/counterSlice";
import manageMetalsReducer from "./slices/manageMetals";
import settingSlice from "./slices/settingSlice";
import metalRateSlice from "./slices/metalRateSlice";
import customerReducer from "./customer/CustomerSlice";
import offerReducer from "./Offers/OfferSlice";
import carouselSlice from "./slices/CarouselSlice";
import productListSlice from "./Product/ProductListSlice";
import storeReducer from "./StoreList/StoreSlice";
import offlineTransactionReducer from "./OfflineTransaction/OfflineTSlice";
import giftsReducer from "./Gifts/GiftsSlice";
import metalReducer from "./GetMetals/metalSlice";
import bullionDepositReducer from "./BullionDeposit/bullionDepositSlice";
import kycReducer from "./Kyc/kycSlice";
import appConfigReducer from "./Configuration/configurationSlice";
import settingsReducer from "./settings/settingsSlice";
import redeemOrdersReducer from "./Order/RedeemOrdersSlice";
import sellOrdersReducer from "./Order/SellOrdersSlice";
import contentReducer from "./Content/ContentSlice";
import transactionsReducer from "./Transactions/TransactionsSlice";
import dashboardReducer from "./Dashboard/dashboardSlice";
import bullionSlice from "./Bullion/BullionSlice";
import categorySlice from "./Product/ProductCategorySlice";
import subscriptionPlanReducer from "./sagas/Subscription/SubscriptionSlice";
import themeReducer from "./AppTheme/AppThemeSlice";
import jewellerReportReducer from "./JewellerList/JewellerReportSlice";
import couponReducer from "./sagas/Coupon/CouponSlice";
// import requiredReducer from "./Required/requiredSlice";
import followUpReducer from "./FollowUp/followupSlice";
import metalRewardsReducer from "./MetalRewards/metalRewardsSlice";
import requiredReducer from "./Required/requiredSlice";
import productOrderReducer from "./ProductOrder/productOrdersSlice";
import referralReducer from "./Referral/referralSlice";
import countryReducer from "./CountryList/CountrySlice"
import bookingBullionReducer from "./BookingBullion/bookingBullionSlice";
import ticketsReducer from "./Tickets/ticketSlice";
import trainingReducer from "./Training/trainingSlice";
import dashboardInfoReducer from "./DashboardInfo/DashboardInfoSlice";
import jewelleryReducer from "./Jewellery/JewellerySlice";
import jewellerDocumentReducer from "./JewellerDocument/jewellerDocumentSlice";
import customerCouponReducer from "./CustomerCoupon/customerCouponSlice";
import luckyDrawOptimReducer from "./LuckyDrawOptim/luckyDrawOptimSlice";
import luckyDrawBannerReducer from "./LuckyDrawBanner/luckyDrawBannerSlice";
import luckyDrawPopupReducer from "./LuckyDrawPopup/luckyDrawPopupSlice";
// Reset constant
const RESET_STORE = "RESET_STORE";

const rootReducer = combineReducers({
  country:countryReducer,
  productOrders: productOrderReducer,
  referral:referralReducer,
 
  jewellerReport: jewellerReportReducer,
  dashboard: dashboardReducer,
  transactions: transactionsReducer,
  content: contentReducer,
  sellOrders: sellOrdersReducer,
  redeemOrders: redeemOrdersReducer,
  settingData: settingsReducer,
  appConfig: appConfigReducer,
  kyc: kycReducer,
  bullionDeposit: bullionDepositReducer,
  metal: metalReducer,
  gifts: giftsReducer,
  offlineTransaction: offlineTransactionReducer,
  customer: customerReducer,
  counter: counterReducer,
  blocklist: blocklistReducer,
  sipplan: sipplanReducer,
  admin: adminReducer,
  metals: manageMetalsReducer,
  jeweller: jewellerReducer,
  store: storeReducer,
  setting: settingSlice,
  metalRate: metalRateSlice,
  carousel: carouselSlice,
  productlist: productListSlice,
  offer: offerReducer,
  bullions: bullionSlice,
  productCategory: categorySlice,
  subscriptionPlan: subscriptionPlanReducer,
  coupon: couponReducer,
  lead: requiredReducer,
  followUp: followUpReducer,
  theme: themeReducer,
  metalRewards: metalRewardsReducer,
  bookingBullion:bookingBullionReducer,
  tickets:ticketsReducer,
  training:trainingReducer,
  dashboardInfo: dashboardInfoReducer,
  jewellery: jewelleryReducer,
  jewellerDocument: jewellerDocumentReducer,
  customerCoupon: customerCouponReducer,
  luckyDrawOptim: luckyDrawOptimReducer,
  luckyDrawBanner: luckyDrawBannerReducer,
  luckyDrawPopup: luckyDrawPopupReducer,
});
const appReducer = rootReducer;

const resettableReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  stateReconciler: hardSet,
  whitelist: [
    "counter",
    "auth",
    "admin",
    "sipplan",
    "store",
    "blocklist",
    "jeweller",
    "metalRate",
    "customer",
    "offlineTransaction",
    "gifts",
    "metals",
    "bullionDeposit",
    "kyc",
    "appConfig",
    "carousel",
    "offer",
    "settingData",
    "redeemOrders",
    "sellOrders",
    "content",
    "transactions",
    "dashboard",
    "bullions",
    "metalRate",
    "customer",
    "carousel",
    "productlist",
    "theme",
    "subscriptionPlan",
    "jewellerReport",
    "coupon",
    "lead",
    "followup",
    "productOrders",
    "metalRewards",
    "referral",
    "country",
    "bookingBullion",
    "tickets",
    "training",
    "dashboardInfo",
    "jewellery",
    "customerCoupon"
  ],
};

const persistedReducer = persistReducer(persistConfig, resettableReducer);

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
  devTools: true,
});

// Run saga
sagaMiddleware.run(rootSaga);

// Create persistor
export const persistor = persistStore(store);
